import { OptionsStackingValue } from 'highcharts';

export const PRIMARY_Y_AXIS_INDEX = 0;

export const OPTIONS_STACKING_VALUES: readonly OptionsStackingValue[] = [
  'normal',
  'overlap',
  'percent',
  'stream'
] as const;
